import { uiSlice } from './ui-slice';

export const { setMainMenuItemsAndRoles, setLoading } = uiSlice.actions;
export default uiSlice;
